import WebinarCarousel from "@components/Layouts/Carousel/WebinarCarousel";
import fetchContextWithFallback from "@helper/fetchContextWithFallback";
import { getGTMData, getMetaData } from "@helper/getMetaData";
import BHBasePage, { BHBasePageProps } from "@routes/BHBasePage";
import ErrorPage from "@routes/ErrorPage";
import WidgetWrapper from "@routes/Home/HomePageLayout/WidgetWrapper";
import { Heading } from "@sphtech/sph-web-ui/elements/Heading";
import { ResponseType, type TRouteWithRedirect } from "@sphtech/web2-core/ssr";
import { PageAdTargetingTypeEnum } from "@typings/Ads.d";
import { ClientLoaderFunctionArgs, useLoaderData } from "react-router";

import NoWebinar from "./NoWebinar";
import { fetchWebinarData, WebinarPayloadResponseType } from "./Webinar.server";
import WebinarMetaData from "./WebinarMetaData";
import WebinarRecordedVideo from "./WebinarRecordedVideo";

const uniqueSectionName = "webinar";
export function meta() {
  return [getMetaData(WebinarMetaData(uniqueSectionName).metaTags)];
}

export default function Webinar() {
  const dataLoaderResponse: TRouteWithRedirect<
    WebinarPayloadResponseType,
    string
  > = useLoaderData();

  if (dataLoaderResponse.type === ResponseType.SERVER_ERROR) {
    return <ErrorPage message="Something went wrong" />;
  }

  if (dataLoaderResponse.type === ResponseType.SUCCESS) {
    const data = dataLoaderResponse.payload.data;
    const basePageProps: BHBasePageProps = {
      uniqueSectionName,
      pageAdTargetValue: PageAdTargetingTypeEnum.LISTING,
    };

    return (
      <BHBasePage {...basePageProps}>
        <WidgetWrapper>
          {data.length === 0 ? (
            <NoWebinar />
          ) : (
            <>
              <Heading
                Element="h1"
                className="text-blue-100 text-lg font-medium leading-[31px] mb-2"
              >
                Webinar Akan Datang
              </Heading>
              <WebinarCarousel renderItems={data} />
            </>
          )}
          <WebinarRecordedVideo />
        </WidgetWrapper>
      </BHBasePage>
    );
  }
}

export async function loader() {
  const data = await fetchWebinarData();
  const { gaData } = WebinarMetaData(uniqueSectionName);
  return {
    ...data,
    gtm: getGTMData(gaData),
  };
}

export async function clientLoader(args: ClientLoaderFunctionArgs) {
  return await fetchContextWithFallback<WebinarPayloadResponseType | null>(
    args,
  );
}
